export default __webpack_public_path__ + "images/cfa1a1127f8117ab70cf61c1c046a9b7-PH_P_Mobile.jpg";